import React, { useEffect, useState, useRef } from 'react';
import { Container, Button, Message } from 'semantic-ui-react'
import { Icon, Table, Input, Pagination, Grid} from 'semantic-ui-react'
import { API } from 'aws-amplify';
//import _ from 'lodash';
import ModifyItem from './modifyItem.js';
import DeleteItem from '../components/deleteItem.js'

let apiName = 'apirestcustomers2';
let path = '/customers';

const Customers = () => {

    const blankMessage = {msgText: "", msgType: "E"}

    const [inputId, setInputId] = useState("")
    const [inputCity, setInputCity] = useState("")
    const [inputCountry, setInputCountry] = useState("")
    const [customers, setCustomers] = useState([])
    const [pageNumber, setPageNumber] = useState(1)
    const [totalPages, setTotalPages] = useState(10)
    const [remountComponent, setRemountComponent] = useState(0);
    const [requestNewSearch, setRequestNewSearach] = useState(false)
    const [message, setMessage]= useState(blankMessage)
    const isFirstRender = useRef(true);
    const pageSize = 10

    // react on change of page number to fetch new page from server
    useEffect(() => {
        if ( isFirstRender.current ) {
            console.log("**** first render")
            isFirstRender.current = false;
            return 
          }

        console.log("pagenumber changed to", pageNumber);
        getCustomer(inputId, inputCity, inputCountry)
        }, [pageNumber, requestNewSearch])


    //Function to fetch from our backend and update customers array
    function getCustomer(e) {

        console.log("### Entering getCustomer with pageNummber", pageNumber)
        setRequestNewSearach(false)
        setMessage(blankMessage)
        let queryStringParams = {
            queryStringParameters: {
                limit: pageSize,
                offset: (pageNumber-1)*pageSize
            }
        }
        if (inputCity !== '') {
            queryStringParams.queryStringParameters.city= inputCity
        } 
        if (inputCountry !== '') {
            queryStringParams.queryStringParameters.country= inputCountry
        } 
        
        API.get(apiName, path + "/" + inputId
            , queryStringParams)
            .then(response => {
                console.log("getCustomer response is",response)
                setCustomers(response)

            if (response.length>0){}
                console.log(response[0]._count)
                setTotalPages(Math.ceil(response[0]._count/pageSize))

            })
            .catch(error => {
                console.log(error) // TODO: Handle errors without response property not returned by the service
                setMessage({msgText: error.response.data.message, msgType: "W"})
                if (error.response.data.statusCode === 404)
                    setCustomers([])

            })
        }

    
        return (
            <div><Message positive={message.msgType === 'I'} warning={message.msgType === 'W'} error={message.msgType === 'E'}
                    onDismiss={() => setMessage(blankMessage)}
                    content = {message.msgText} 
                    hidden = {message.msgText.length === 0}>
                    <Icon name={message.msgType === 'W' ? 'exclamation circle' : message.msgType === 'E' ?'times circle' : 'check circle'}  
                        color={message.msgType === 'W' ? 'yellow' : message.msgType === 'E' ?'red' : 'green'}/>
                    {message.msgText}
                    </Message>
                <div>
                    <Grid columns='equal'>
                        <Grid.Column>
                        <Input placeholder="Customer ID" type="text" value={inputId} onChange={(e) => setInputId(e.target.value)} />
                        </Grid.Column>
                        <Grid.Column>
                        <Input placeholder="City" type="text" value={inputCity} onChange={(e) => setInputCity(e.target.value)} />
                        </Grid.Column>
                        <Grid.Column>
                        <Input placeholder="Country" type="text" value={inputCountry} onChange={(e) => setInputCountry(e.target.value)} />
                        </Grid.Column>
                        <Grid.Column textAlign='left'>
                        <Button onClick={() => {setPageNumber(1)
                                            console.log("searchbutton", pageNumber)
                                            setRemountComponent(Math.random());
                                            setRequestNewSearach(true)
                                            }
                                    } size='small'>
                            <Icon name='search'/>
                                         Search</Button>
 

                        </Grid.Column>
                    <Grid.Column textAlign='right'>
                    <ModifyItem id={0} setMessage={setMessage} />
                    </Grid.Column>
                    
                    </Grid>
                </div>

                <Container style={{ padding: 10 }}>
                    <Table  celled selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell/>
                                <Table.HeaderCell>Company Name</Table.HeaderCell>
                                <Table.HeaderCell>City</Table.HeaderCell>
                                <Table.HeaderCell>Country</Table.HeaderCell>
                                <Table.HeaderCell/>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {
                                customers.map((customer, key) =>
                                    <Table.Row key={key}>
                                        <Table.Cell><ModifyItem id = {customer.customer_id} setMessage={setMessage}/> </Table.Cell>
                                        <Table.Cell>{customer.company_name}</Table.Cell>
                                        <Table.Cell>{customer.city}</Table.Cell>
                                        <Table.Cell>{customer.country}</Table.Cell>
                                        <Table.Cell><DeleteItem id = {customer.customer_id} 
                                                                name = {customer.company_name} 
                                                                setMessage={setMessage}/></Table.Cell>
                                    </Table.Row>
                                )
                            }
                        </Table.Body>

                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan='3'>
                                    <div key={remountComponent}>
                                    <Pagination floated='right' pagination
                                    totalPages={totalPages}
                                    onPageChange={(event, data) => {console.log(data.activePage);
                                                                    setPageNumber(data.activePage);                                                                    
                                                                    }}>
                                    defaultActivePage={1}
                                    activePage={pageNumber}
                                    </Pagination></div>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>


                </Container>
            </div>
        );
    
}
export default Customers;